import { List } from 'immutable'
/*
 *   Pudding  オプション条件
 *   構成比：ratio、実数：val
 */
export default List(['ratio', 'val'])
